import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_SK.json';
import exercises from './PILATES_EXERCISES_SK.json';
import recipes from './PILATES_RECIPES_SK.json';

export const PILATES_DATA_SK: ServiceData = {
  articles,
  exercises,
  recipes,
};
